export function cpicker(ctx) {
    return {
        styles: {
            // scale_width/pad_inner intentionally NOT overridden here — schema
            // defaults (30/20) already match lv_theme_material.c:602/606
            // (cpicker_bg: LV_DPX(30)/LV_DPX(20)); this theme previously
            // shadowed them with incorrect 15/10 (INCORRECT vs both schema
            // default and firmware — removed).
            main:      { bg_color: ctx.COLOR_SCR, bg_opa: 255, radius: 999 },  // #eaeff3 = COLOR_SCR light; radius=circle per LV_RADIUS_CIRCLE
            indicator: { border_width: 2, border_color: '#808080' },  // cpicker_indic border = LV_COLOR_GRAY
        },
    };
}
